import { useEffect, useRef, useState } from "react";
import { useTheme } from "../../../../components/hooks/useTheme";
import { useNavigate } from "react-router-dom";
import { Stack } from '@mui/material';
import { ArrowDropDown, ArrowDropUp, ArrowLeftOutlined } from '@mui/icons-material';
import baseURL from "../../../../configs/api";
import { AllGateways } from "./AllGateways";
import Cookies from "js-cookie";
import useTenant from "../../../../components/hooks/useTenant";

export const Gateways = () => {
  const { handleTenantError }: any = useTenant();
   const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
  const { theme, themeStyles } = useTheme();
  const navigate = useNavigate();
  const [isMenuShown, setIsMenuShown] = useState<boolean>(false);
  const [menuData, setMenuData] = useState<any[]>([]);
  const dropdownRef = useRef<HTMLUListElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (
        dropdownRef.current && !dropdownRef.current.contains(event.target) &&
        buttonRef.current && !buttonRef.current.contains(event.target)
      ) {
        setIsMenuShown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);

  useEffect(() => {
    fetch(`${baseURL}paymentGatewayMenu`, {
      headers: {
         'X-Tenant-ID': tenantId,
      }
    })
      .then((res) => res.json())
      .then((data) => {
        const grouped = data.reduce(
          (result: any[], item: any) => {
            if (!result[item.region]) {
              result[item.region] = [];
            }
            result[item.region].push(item);
            return result;
          },
          {}
        );

        setMenuData(() =>
          Object.keys(grouped).map((key) => {
            return {
              region: key,
              provider: grouped[key],
            };
          })
        );
        handleTenantError(null);
      })
      .catch((error) => {                  
        handleTenantError(error);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className={`px-[24px] py-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
      <div className={`w-full ${themeStyles.main.tailwindMainBg} border ${themeStyles.main.borderColor} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.5`}>
        <div className="flex items-center justify-end">
          <div className="flex items-center gap-2.5">
            <Stack spacing={1} direction="row">
              <button
                className={`px-[8px] py-[6px] bg-[#66bb6a] rounded-lg border ${themeStyles.main.borderColor} text-white flex items-center gap-1.5`}
              >
                Signup with Stripe
              </button>

              <ul className="inline-block">
                <li className="relative bg-transparent p-0 w-full">
                  <button
                    ref={buttonRef}
                    className={`px-[8px] py-[6px] bg-[#167AC3] rounded-lg border ${themeStyles.main.borderColor} text-white flex items-center gap-1.5 w-full`}
                    onClick={() => setIsMenuShown(!isMenuShown)}
                  >
                    Add Gateway
                    {isMenuShown ? (
                      <ArrowDropUp sx={{ fontSize: 20 }} />
                    ) : (
                      <ArrowDropDown sx={{ fontSize: 20 }} />
                    )}
                  </button>

                  <ul
                    ref={dropdownRef}
                    className={`absolute left-0 mt-2 border shadow-lg rounded-md z-10 w-full ${themeStyles.main.textHeadingColor}`}
                    style={{ 
                      display: isMenuShown ? 'block' : 'none',
                      backgroundColor: themeStyles.topBar.bg,
                      color: themeStyles.topBar.tailwindTextColor
                    }}
                  >
                    {menuData.map((item: any, index: number) => (
                      <li key={index} className="relative group">
                        <div className={`flex items-center justify-between px-4 py-2 ${theme === "dark" ? "hover:bg-white/10" : "hover:bg-black/10"} cursor-pointer`}>
                          <span className="text-sm">{item.region}</span>
                          <ArrowLeftOutlined sx={{ fontSize: 18 }} />
                        </div>

                        <ul 
                          className={`absolute top-0 right-full mt-0 w-48 border shadow-lg rounded-md hidden group-hover:block z-20`}
                          style={{                    
                            backgroundColor: themeStyles.topBar.bg,
                            color: themeStyles.topBar.tailwindTextColor
                          }}
                        >
                          {item.provider.map((value: any, idx: number) => (
                            <li
                              key={idx}
                              onClick={() =>
                                navigate('/admin/paymentgateways/paymentgatewaysform', {
                                  state: { id: value.id, provider: value.provider },
                                })
                              }
                              className={`px-4 py-2 ${theme === "dark" ? "hover:bg-white/10" : "hover:bg-black/10"} cursor-pointer text-sm`}
                            >
                              {value.provider}
                            </li>
                          ))}
                        </ul>
                      </li>
                    ))}
                  </ul>
                </li>
              </ul>
            </Stack>
          </div>
        </div>

        <div>
          <AllGateways />
        </div>
      </div>
    </div>
  );
};
